var React = require('react');

function HayfieldIdent (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#1f1b37;}")),React.createElement("polygon",{"className":"cls-1","points":"331.34 104.17 373 104.17 373 395.17 331.34 395.17 331.34 268.52 167.82 268.52 167.82 395.17 126.16 395.17 126.16 104.17 167.82 104.17 167.82 229.99 331.34 229.99 331.34 104.17","key":1})]);
}

HayfieldIdent.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 500 500"};

module.exports = HayfieldIdent;

HayfieldIdent.default = HayfieldIdent;
